import { useQuery } from "@tanstack/react-query";

import { useRestApi } from "@/context/api";
import { useCurrentCompany } from "@/context/auth";

import { queryKeys } from "./queryKeys";

export const useDashboardQuery = () => {
  const { getDashboard } = useRestApi().dashboard;
  const currentCompany = useCurrentCompany();

  return useQuery({
    queryKey: [queryKeys.DASHBOARD, currentCompany.id],
    queryFn: () => getDashboard(currentCompany.id),
    staleTime: 60_000,
    retry: 1,
    enabled: !!currentCompany.id,
  });
};
